// Site-wide contact details for Little Ark Preschool
export const CONTACT = {
  schoolName: "Little Ark Preschool",
  tagline: "Big Dreams Begin at Little Ark",
  logoUrl: "https://customer-assets.emergentagent.com/job_happy-learners-ark/artifacts/bhnmrquo_Untitled%20design_20260509_154036_0000.png",
  phone: "+91 99720 07478",
  phoneRaw: "+919972007478",
  whatsapp: "919972007478",
  email: "littleark26@gmail.com",
  address: "Little Ark Preschool, Kanakapura Main Road, Harohalli, Maralawadi Road, Karnataka 562112",
  city: "Harohalli, Karnataka",
  hours: "Mon – Fri, 9:00 AM – 5:00 PM",
  socials: {
    instagram: "https://www.instagram.com/littleark_harohalli?igsh=MWpvYnl1d3ZobGN2bg==",
    facebook: "https://www.facebook.com/share/1NGqi9gB1a/",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=Little+ark+Preschool,+Kanakapura+Main+Road+Harohalli,+Maralawadi+Road,+Harohalli,+Karnataka+562112&output=embed",
  mapsLink: "https://maps.app.goo.gl/Yk5MiZXf4bVmCS639",
};

export const buildWhatsAppLink = (msg = "") => {
  const base = `https://wa.me/${CONTACT.whatsapp}`;
  return msg ? `${base}?text=${encodeURIComponent(msg)}` : base;
};
